import cn from 'classnames';
import React, {FC} from 'react';

import {IDashboardEntry} from 'modules/data/data-types';

import {WidgetWrapper} from '../../components/widget-wrapper';
import {useStatisticsInitialization} from '../../hooks/use-statistics-initialization';
import {StatisticsEmptyPlaceholder} from '../statistics-empty-placeholder';
import {HalfCircleChart} from './half-circle-chart';

import './half-circle-statistics.less';

interface IHalfCircleStatisticsProps {
    entries: IDashboardEntry;
    title?: string;
}

export const HalfCircleStatistics: FC<IHalfCircleStatisticsProps> = ({
    entries, title,
}: IHalfCircleStatisticsProps) => {
    const {statisticsData} = useStatisticsInitialization({
        entries,
        settings: {lowercaseEntityKeys: true, useReducedAvailableBarColors: false},
    });

    return (
        <WidgetWrapper title={title}>
            <div className={cn('half-circle-statistics')}>
                <div className={cn('half-circle-statistics__description')}>
                    {
                        statisticsData.map(({key, value, color}) => (
                            <div
                                key={key}
                                className={cn('half-circle-statistics__description__entry')}
                            >
                                <div
                                    style={{backgroundColor: color}}
                                    className={cn('half-circle-statistics__description__entry__list-marker')}
                                />
                                <span className={cn('half-circle-statistics__description__entry__key')}>{key}</span>
                                <span>{value}</span>
                            </div>
                        ))
                    }
                </div>
                <div className={cn('half-circle-statistics__chart')}>
                    {statisticsData?.length
                        ? <HalfCircleChart {...{statisticsData}} /> : <StatisticsEmptyPlaceholder />}
                </div>
            </div>
        </WidgetWrapper>
    );
};
